import { Link } from "@mui/material";
import React, { useState } from "react";
import "../asset/css/footer.css";
import tvImage from "../asset/images/Button_GoToMainPlayer2.png";
import main_logo from "../asset/images/logo.png";
import user_menu_logo from "../asset/images/Button_goToUserPage2.png";
import { NavLink, useNavigate } from "react-router-dom";

function Footer() {
  const userDetails = sessionStorage.getItem("userDetails");

  return (
    <>
	<footer className="footer mt-auto py-3">
        <div className="container-fluid">
            <div className="row mm-0"> 
                <div className="col-md-6 col-12 text-center text-md-start mb-2 mb-md-0 text-white mps-4 mp-0">
                    Tvadi © Copyright 2024
                </div>
                <div className="col-md-6 col-12 text-center text-md-end mpe-4 mp-0">
                    <a href="#" className="me-3 text-white">Terms Of Service</a>
                    <a href="#" className="text-white">Privacy Policy</a>
                </div>
            </div>
        </div>
    </footer>
          {/* <footer className="footer">
            <Link>
              <ul className="ul-div">
                <NavLink className="navLink" to="/">
                  Home
                </NavLink>
                <NavLink className="navLink" to="/about">
                  About us
                </NavLink>
                <NavLink className="navLink" to="/playlist">
                  My Playlist
                </NavLink>
                <NavLink className="navLink" to="/creator">
                  Playlist Creator
                </NavLink>
                <NavLink className="navLink" to="/contact">
                  Contact
                </NavLink>
              </ul>
            </Link>
          </footer> */}
    </>
  );
}
// className={OpenMenuBar?"dropDown":"dropDown hidden"}
// onClick={OpenMenuBar?setOpenMenuBar(false):setOpenMenuBar(true)}
export default Footer;
